// calculatePopupNotificationSize.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';
import {
  POSITION_CENTER,
  POSITION_BOTTOM,
  POSITION_TOP,
  POSITION_FULLSCREEN,
  CONTENT_SIZE_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';
import getCenterPopupNotificationContentSize from '../resource/getCenterPopupNotificationContentSize.js';
import getTopAndBottomPopupNotificationContentSize from '../resource/getTopAndBottomPopupNotificationContentSize.js';
import getFullscreenPopupNotificationContentSize from '../resource/getFullscreenPopupNotificationContentSize.js';

/**
 * Calculate popup notification size
 * @kind action
 * @return {Promise} Action promise.
 */
const calculatePopupNotificationSize = () => async (dispatch, getState) => {
  const deviceWidth = getOperationData(getState(), ['device'], 'width');
  const deviceHeight = getOperationData(getState(), ['device'], 'height');

  const centerSize = getCenterPopupNotificationContentSize({
    deviceWidth,
    deviceHeight,
  });
  const fullscreenSize = getFullscreenPopupNotificationContentSize({
    deviceWidth,
    deviceHeight,
  });
  const topAndBottomSize = getTopAndBottomPopupNotificationContentSize({
    deviceWidth,
    deviceHeight,
  });

  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: CONTENT_SIZE_SELECT_PATH_PREFIX,
      data: {
        [POSITION_CENTER]: centerSize,
        [POSITION_TOP]: topAndBottomSize,
        [POSITION_BOTTOM]: topAndBottomSize,
        [POSITION_FULLSCREEN]: fullscreenSize,
      },
    },
  });
};

export default calculatePopupNotificationSize;
